import React, { useState, useEffect } from "react";
import "./index.sass";

const FearGreed = ({ value = 15, label = "Extreme fear" }) => {
  const title = "Fear & Greed";

  const segments = [
    { color: "#e84a8a", percentage: 25 },
    { color: "#f5a623", percentage: 25 },
    { color: "#f5d03b", percentage: 25 },
    { color: "#2dd4bf", percentage: 25 },
  ];

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isSmallMobile = windowWidth <= 448;
  const isMobile = windowWidth <= 640;

  const svgWidth = isSmallMobile ? 120 : isMobile ? 140 : 180;
  const svgHeight = isSmallMobile ? 65 : isMobile ? 75 : 95;

  const strokeWidth = isSmallMobile ? 6 : 8;
  const offsetValue = isSmallMobile ? 3.6 : 2.8;

  const radius = svgWidth / 2 - 10;
  const centerX = svgWidth / 2;
  const centerY = svgHeight;

  const getCoords = (angle) => {
    const rad = (angle - 180) * (Math.PI / 180);
    return {
      x: centerX + radius * Math.cos(rad),
      y: centerY + radius * Math.sin(rad),
    };
  };

  const createArc = (startAngle, endAngle) => {
    const s = getCoords(startAngle + offsetValue);
    const e = getCoords(endAngle - offsetValue);
    return `M ${s.x} ${s.y} A ${radius} ${radius} 0 0 1 ${e.x} ${e.y}`;
  };

  const pointerAngle = (value / 100) * 180;
  const pointerPos = getCoords(pointerAngle);

  return (
    <div className="fear-greed-card">
      <h3 className="fear-greed-card__title">{title}</h3>

      <div className="fear-greed-card__gauge">
        <svg
          width={svgWidth}
          height={svgHeight + 15}
          viewBox={`0 0 ${svgWidth} ${svgHeight + 15}`}
          className="fear-greed-card__svg"
        >
          {segments.map((segment, index) => {
            const step = 180 / segments.length;
            const startAngle = index * step;
            const endAngle = (index + 1) * step;

            return (
              <path
                key={index}
                d={createArc(startAngle, endAngle)}
                fill="none"
                stroke={segment.color}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
              />
            );
          })}

          <circle
            cx={pointerPos.x}
            cy={pointerPos.y}
            r={isSmallMobile ? "5" : "7"}
            fill="#fff"
            stroke="#C5C5C5"
            strokeWidth="1"
            className="fear-greed-card__pointer"
          />
        </svg>

        <div className="fear-greed-card__center">
          <span className="fear-greed-card__value">{value}</span>
          <span className="fear-greed-card__label">{label}</span>
        </div>
      </div>
    </div>
  );
};

export default FearGreed;
